import { Alert } from '../utils/alert';

export class ResourcePage {
  static start() {
    const $elements = $('.resource-page');

    if ($elements) {
      $elements.each(function init_resource_pages() {
        const $element = $(this);

        $element.data('resourcepage', new ResourcePage($element));
      });
    }
  }

  constructor($element) {
    this.$element = $element;
    this.url = $element.data('resource-url');

    if (this.url) this.bind_events();
  }

  bind_events() {
    this.$element.on('click', '[data-resource-action]', (event) => this.handle_resource_action(event));
  }

  handle_resource_action(event) {
    const $element = $(event.currentTarget);
    const confirmation = ($element.data('resource-confirm') ? $element.data('resource-confirm') : null);

    if ($element.parents('.resource-list').length > 0) {
      return;
    }

    if (!$element.hasClass('disabled') && (confirmation == null || window.confirm(confirmation))) {
      const ajax_settings = {
        url: `${this.url}/${$element.data('resource-action')}`,
        dataType: 'json',
        contentType: 'application/json',
        success: (data) => this.handle_resource_action_success(data, $element),
        error: (data) => this.handle_resource_action_failure(data),
      };

      if ($element.data('resource-method')) {
        ajax_settings.type = $element.data('resource-method');
      }
      else {
        ajax_settings.type = 'POST';
      }

      if ($element.data('resource-value') !== undefined) {
        ajax_settings.data = JSON.stringify({ value: $element.data('resource-value') });
      }

      $.ajax(ajax_settings);
    }
  }

  handle_resource_action_success(data, $element) {
    if (data.success) {
      if (data.message) {
        Alert.success(data.message);
      }

      if (data.replace) {
        $element.replaceWith(data.replace);
      }

      if (data.remove) {
        $element.remove();
      }

      if (data.disabled) {
        $element.addClass('disabled');
      }

      if (data.value && $element.data('resource-refresh')) {
        const refresh_selector = $element.data('resource-refresh');
        const $refresh = this.$element.find(refresh_selector);

        $refresh.html(data.value);
      }

      if (data.next_value !== undefined) {
        if ($element.data('resource-value') !== undefined) {
          $element.data('resource-value', data.next_value);
        }

        if ($element.data('resource-toggle')) {
          if (data.next_value) {
            $element.find('.toggle-on').removeClass('d-none');
            $element.find('.toggle-off').addClass('d-none');
          }
          else {
            $element.find('.toggle-on').addClass('d-none');
            $element.find('.toggle-off').removeClass('d-none');
          }
        }
      }
    }

    else {
      this.handle_resource_action_failure(null, data);
    }
  }

  static handle_resource_action_failure(request, data) {
    if (data && data.error) {
      Alert.error(data.error);
    }
    else {
      Alert.error('Es ist ein Fehler aufgetreten.');
    }

    if (request != null) {
      console.error(request.responseText);
    }
  }
}
